import store from '@/store/store'

// Function to get the navigation menu items based on the user's repository
export default function getSupplierNavigation() {
  const user = store.state.user || {}
  const userRepositoryId = user.repository

  // Build navigation items array
  const navigationItems = [
    {
      title: 'Centre de Support',
      route: 'supplier-support-center',
      icon: 'HeadphonesIcon',
    },
    {
      title: 'Tableau de bord',
      route: 'dashboard',
      icon: 'HomeIcon',
    },
  ]

  // Add "Ajouter un colis" menu item with conditional behavior:
  // - Repository 6: Use internal create order page
  // - Other repositories: Redirect to external tracking URL
  if (userRepositoryId === 6) {
    navigationItems.push({
      title: 'Ajouter un colis',
      route: 'order-add',
      icon: 'PlusCircleIcon',
    })
  } else {
    navigationItems.push({
      title: 'Ajouter un colis',
      href: process.env.VUE_APP_TRACKING_URL || 'https://tracking.b2cdelivery.tn/',
      icon: 'PlusCircleIcon',
    })
  }

  // Add remaining menu items
  navigationItems.push(
    {
      title: 'Liste des colis',
      route: 'orders-index',
      icon: 'PackageIcon',
    },
    {
      title: 'Bon de livraison',
      route: 'delivery-note-list',
      icon: 'FileTextIcon',
    },
    {
      title: 'Liste des pickups',
      route: 'pickup-list',
      icon: 'TruckIcon',
    },
    {
      title: 'Créer un pickup',
      route: { name: 'pickup-add' },
      icon: 'ShoppingCartIcon',
    },
    {
      title: 'Liste des règlements',
      icon: 'CreditCardIcon',
      route: 'invoice-list',
    },
    {
      title: 'Bon de retour',
      icon: 'RotateCcwIcon',
      route: 'bon-retour-list',
    },
    {
      title: 'Support',
      icon: 'mdi-lifebuoy',
      children: [
        {
          title: 'Tickets de support',
          icon: 'HelpCircleIcon',
          route: 'SupportTicketList',
        },
        {
          title: 'Demandes de nouvelle livraison',
          icon: 'RefreshCwIcon',
          route: 'RedeliveryRequestList',
        },
        {
          title: 'Demandes de modification de prix',
          icon: 'DollarSignIcon',
          route: 'PriceChangeRequestList',
        },
      ],
    },
  )

  return navigationItems
}
